import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const materialOutSlice = createSlice({
    name: 'materialOut',
    initialState,
    reducers: {
        funGetmaterialOut(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( materialOut ) => {
                return{
                    ...materialOut,
                    forwardingDt: m.date({ value: materialOut.forwardingDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const materialOutActions = materialOutSlice.actions;
export default materialOutSlice.reducer;